import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';
import { PaperProps, statusOptions, statusSuccess } from 'constants';
import {
  getDialogHeading,
  renderSaveCancelButtons,
  useNotification,
  dropDownValidation,
  fieldValidation,
  showBackdropLoader,
  emptyFunction,
  onSave,
  refinePayload
} from 'utils/commonUtils';
import { putSessionStatus } from 'layouts/tutoring/services/tutoringApi';

const bookedSessionStatusDialogSchema = yup.object().shape({
  status: dropDownValidation,
  statusNote: fieldValidation(4000),
});

const BookedSessionStatusDialog = (props) => {
  const {
    bookedSessionStatusDialog,
    setBookedSessionStatusDialog,
    isFormLoading,
    statusForm,
    fetchBookedSessions,
  } = props;

  const dispatch = useDispatch();

  const {
    setOpenNotification,
    setNotificationMessage,
    NotificationPopup,
  } = useNotification();

  const [loadingButton, setLoadingButton] = useState(false);

  const { sessionId, status, statusNote } = statusForm || {};

  const defaultValue = {
    status: status === 'booked' ? '' : status,
    statusNote: statusNote,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(bookedSessionStatusDialogSchema),
  });

  const { handleSubmit, control, reset, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.status, defaultValue.statusNote]);

  const handleClose = () => {
    setBookedSessionStatusDialog(false);
    reset(defaultValue);
  };

  const onSubmit = async (data) => {
    const { status, statusNote } = data;
    const payload = {
      status,
      note: statusNote,
    };
    onSave(
      statusSuccess,
      false,
      emptyFunction,
      putSessionStatus,
      refinePayload(payload),
      sessionId,
      fetchBookedSessions,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton,
      loadingButton
    );
  };

  return (
    <>
      {showBackdropLoader(isFormLoading)}
      <Dialog open={bookedSessionStatusDialog} PaperProps={PaperProps}>
        {getDialogHeading('Status', handleClose)}
        <GridForm container spacing={2}>
          <Grid item xs={12}>
            <FormInputDropdown
              name="status"
              control={control}
              options={statusOptions}
              label="Status"
              helperText={errors?.status?.message}
              errors={!!errors.status}
            />
            <FormInputText
              name="statusNote"
              type="text"
              control={control}
              label="Note"
              helperText={errors?.statusNote?.message}
              errors={!!errors.statusNote}
              multiline
              rows={2}
            />
            <MDBox mt={1}></MDBox>
            {renderSaveCancelButtons(
              handleClose,
              handleSubmit(onSubmit),
              loadingButton,
              false
            )}
          </Grid>
        </GridForm>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export default BookedSessionStatusDialog;
